module.exports = __webpack_public_path__ + "assets/img/thumb-openinvest-get-started.d6b86e24.jpg";